import type { SerializedError } from '@reduxjs/toolkit'
import { createEntityAdapter, createSlice } from '@reduxjs/toolkit'
import type { Nullable } from 'common/types'

import type { MapFetchingResult, MapFetchingStatus } from '../../types'
import { calculateMapFetching } from './mapFetchingActions'

export const mapFetchingAdapter = createEntityAdapter<MapFetchingResult>({
  selectId: entity => entity.projectId,
})

const initialValue: { status: MapFetchingStatus; error: Nullable<SerializedError> } = {
  status: 'ready',
  error: null,
}

const initialState = mapFetchingAdapter.getInitialState(initialValue)
export const mapFetchingSlice = createSlice({
  name: 'mapFetching',
  initialState,
  reducers: {
    clearMapFetching() {
      return initialState
    },
  },
  extraReducers: builder => {
    builder
      .addCase(calculateMapFetching.pending, state => {
        state.status = 'calculating'
      })
      .addCase(calculateMapFetching.fulfilled, (state, action) => {
        mapFetchingAdapter.upsertOne(state, action.payload)
        state.status = 'ready'
      })
      .addCase(calculateMapFetching.rejected, (state, action) => {
        state.status = 'failed'
        state.error = action.error
      })
  },
})

export default mapFetchingSlice.reducer
